/* 布局 */
//前台
import Layout from "@views/layout";

const messageRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
        {
        path: "message/list",
        name: "MESSAGE",
        meta: {
            title: "消息通知",
            keepAlive:true
        },
        component: () => import("@views/business/message/index.vue"),
    },
        ],
};

export default messageRouter;
